import React from 'react';
import PropTypes from 'prop-types';

import TextField from '@mui/material/TextField';
import { FormControl, FormHelperText, Tooltip } from '@mui/material';
import { withStyles } from '@mui/styles';

import { NumericFormat } from 'react-number-format';


const styles = {
	formControl: {
		marginTop: 4,
	},
	tooltip: {
		whiteSpace: 'pre-line',
	}
};

function isAllowed(values) {
	return !values.value.includes('.');
}

class CompactTextFieldV2 extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			value: this.props.value,
		};
		this.lastPropValue = this.props.value;
	}

	// getOnKeyDown() {
	// 	if(this.props.onKeyDown) {
	// 		return (event) => {
	// 			if(event.key === 'Enter') {
	// 				this.props.onChange({target: {value: this.state.value}});
	// 			}
	// 			this.props.onKeyDown(event);
	// 		};
	// 	} else {
	// 		return (event) => {
	// 			if(event.key === 'Enter') {
	// 				this.props.onChange({target: {value: this.state.value}});
	// 			}
	// 		};
	// 	}
	// }

	render() {
		// to change value when it changes in props
		let value = this.props.value === this.lastPropValue ? this.state.value : this.props.value;
		this.lastPropValue = this.props.value;

		let helperText = (this.props.error ? this.props.errorText || this.props.helperText : this.props.helperText) || '';
		let textFieldProps = {
			...(this.props.TextFieldProps || {}),
			value: value,
			defaultValue: this.props.defaultValue,
			id: this.props.id,
			label: this.props.label,
			multiline: this.props.multiline || false,
			rows: this.props.multiline === true && this.props.rows ? this.props.rows : '1',
			margin: 'dense',
			variant: 'outlined',
			fullWidth: true,
			required: this.props.required || false,
			inputProps: {
				style: { boxSizing: 'border-box', padding: '8px 10px', height: (this.props.multiline ? 'auto' : '36px') },
			},
			InputLabelProps: {
				shrink: true,
			},
			error: this.props.error,
			disabled: this.props.readOnly || false,
			onChange: (event) => this.setState({ value: event.target.value }),
			onBlur: () => this.props.onChange({ target: { value: this.state.value } }),
			onKeyDown: this.props.onKeyDown,
		};
		return (
			<FormControl fullWidth className={this.props.classes.formControl}>
				<Tooltip title={helperText && <div className={this.props.classes.tooltip} dangerouslySetInnerHTML={{ __html: helperText }} />}>
					{this.props.type === 'number' || this.props.type === 'integer' ?
						<div>
							<NumericFormat
								customInput={TextField}
								valueIsNumericString
								isAllowed={this.props.type === 'integer' ? isAllowed : undefined}

								{...textFieldProps}
							/>
						</div> :
						<TextField
							type={this.props.type || 'text'}
							{...textFieldProps}
						/>}
				</Tooltip>
				{helperText && <FormHelperText>{new DOMParser().parseFromString(helperText, 'text/html').body.textContent || ''}</FormHelperText>}
			</FormControl>
		);
	}
}

CompactTextFieldV2.propTypes = {
	type: PropTypes.string,
	value: PropTypes.string,
	defaultValue: PropTypes.string,
	required: PropTypes.bool,
	helperText: PropTypes.string,

	id: PropTypes.string,
	label: PropTypes.string,
	multiline: PropTypes.bool,
	rows: PropTypes.number,

	onChange: PropTypes.func,
	onKeyDown: PropTypes.func,

	error: PropTypes.bool,
	errorText: PropTypes.string,

	readOnly: PropTypes.bool,

	TextFieldProps: PropTypes.object,

	classes: PropTypes.object,
};

export default withStyles(styles)(CompactTextFieldV2);
